import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs as TabsComponent, Tab as TabComponent } from 'foundations-components/transitional/components/Tabs';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { trackSwitchTab } from '../../utils/usageTracker';
import { ANALYZE_ROUTE, TABS } from '../../constants/Tabs';
import { ONBOARDING_ANALYZE_TAB } from '../../constants/TourConstants';
import { selectTab } from '../../actions/TabsActions';
import { getIsUngatedToAIProjections } from '../../selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = ({
  isDetail
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUngatedToAIProjections = useSelector(getIsUngatedToAIProjections);
  const isAnalyzeRoute = history.location.pathname === ANALYZE_ROUTE;
  const selected = isAnalyzeRoute ? TABS.ANALYZE : TABS.FORECAST;
  useEffect(() => {
    if (isAnalyzeRoute) {
      dispatch(selectTab(TABS.ANALYZE));
    }
  }, [dispatch, isAnalyzeRoute]);
  const handleSelectedChange = useCallback(tab => {
    const tabId = tab;
    trackSwitchTab(isDetail, tabId);
    dispatch(selectTab(tabId));
    history.push(tabId === TABS.ANALYZE ? ANALYZE_ROUTE : '/');
  }, [dispatch, history, isDetail]);
  return /*#__PURE__*/_jsxs(TabsComponent, {
    "data-test-id": "navigation-tabs",
    selected: selected,
    onSelectedChange: handleSelectedChange,
    children: [/*#__PURE__*/_jsx(TabComponent, {
      tabId: TABS.FORECAST,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tabs.forecast.title"
      })
    }), isUngatedToAIProjections && /*#__PURE__*/_jsx(TabComponent, {
      tabId: TABS.ANALYZE,
      "data-tour-step-key": ONBOARDING_ANALYZE_TAB,
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "tabs.analyze.title"
        }), /*#__PURE__*/_jsx(Badge, {
          use: "beta",
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "tabs.analyze.badge"
          })
        })]
      })
    })]
  });
};
export default Tabs;